import React from 'react';
import PropTypes from 'prop-types';
import Search from '../Search';


class ModalSearchFinancial extends React.Component {
    constructor() {
        super();
        this.state = {
            query: '',
            searchText: '',
        };
    }

    componentWillMount() {

    }

    render() {
        const { visible } = this.props;
        return (
            <div
                className="modal bs-example-modal-lg"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalSearchFinancial"
                style={{ display: visible ? 'block' : 'none' }}
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="row" style={{ margin: 20 }}>
                            <h2>Search For</h2>
                            <div className="col-lg-8">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search for..."
                                    onChange={e => this.setState({ searchText: e.target.value })}
                                />
                            </div>
                            <div className="col-lg-2">
                                <span className="input-group-btn">
                                    <button
                                        className="btn btn-default btn-primary"
                                        type="button"
                                        onClick={() => this.setState({ query: this.state.searchText })}
                                    >
                                        <i className="fa fa-search" />
                                    </button>
                                </span>
                            </div>
                        </div>
                        <Search
                            isModal
                            match={{
                                params: {
                                    query: this.state.query,
                                },
                            }}
                            defaultPageSize={5}
                        />
                        <div className="modal-footer">
                            <button
                                className="btn btn-info"
                                type="button"
                                onClick={() => {
                                    this.props.onClose();
                                    this.setState({ query: '' });
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


ModalSearchFinancial.propTypes = {
    onClose: PropTypes.func.isRequired,
};

export default ModalSearchFinancial;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/ModalSearchFinancial.js
// module id = 1009
// module chunks = 0